import { isFundingDevelopmentBadge } from './development-badge.util';

// Construction readiness is independent of sales status and development labels.
// API mappers normalize supported wire values to boolean | null before rendering.
export function propertyConstructionLabel(readyToMove: unknown): string {
    if (readyToMove === true) return 'Ready to move';
    if (readyToMove === false) return 'Under construction';
    return 'Contact us';
}

// Business presentation precedence only: never changes readiness or sale state.
export function propertyDevelopmentLabel(readyToMove: unknown, developmentBadge: unknown): string {
    return isFundingDevelopmentBadge(developmentBadge) ? 'Funding' : propertyConstructionLabel(readyToMove);
}

export function propertyDevelopmentHeading(developmentBadge: unknown): string {
    return isFundingDevelopmentBadge(developmentBadge) ? 'Development' : 'Construction status';
}
